import React from 'react'
import BMenu from './BMenu'
import Navbar from './Navbar'

function NavbarWrapper () {
   return(
        <>
            <Navbar />
            <BMenu /> 
        </>
   )
}

export default NavbarWrapper

